import React, { useEffect } from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormPaging from "../../../../library/form/components/FormPaging";
import FormTitle from '../../../../library/form/components/FormTitle';
import FormButton from '../../../../library/form/components/FormActionButton2';
import ListChoicesRow from './ListChoicesRow';

import { UiView, UiViewHeading, UiTitle, UiAction } from "../../../../library/layout/Index";

const ListChoices = (props) => {
    const { formObject, viewData } = props;

    const triggerRefreshView = () => {
        if(props.parentData){
            formObject.onFormAction({actionName:"listChoice",actionId:"show"}, null, null);
        }
    }

    useEffect(triggerRefreshView, [props.parentData]);

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='List Choices' />
                </UiTitle>
                <UiAction>
                    <FormButton formObject={formObject} ksc="alt+t" rowKey="" headerKey="viewConfig" 
                        action={{ paramName: "manualOpsButtons", actionId: "show",  actionParam: { toggleSel: "1" } }}
                        className="uiActionButton" text={<SarasTrans value="Toggle Show Selected" />}></FormButton>

                    <FormPaging formObject={formObject} />
                </UiAction>
            </UiViewHeading>
            <div className="uiSecContents" >
                {
                    Object.values(viewData).map((row, index) => (
                        <div className="uiSearchRow uiInline" style={{display:"inline-block"}}>
                            <ListChoicesRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        </div>
                    ))
                }

            </div>
        </UiView>
    )
}

export default withView(ListChoices, "listChoice")
